import { ErrorHandler, NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { DriveApp } from './app.component';
import { CommonModule } from '@angular/common';
import { AgGridModule } from "ag-grid-angular/main";
import { AngularSplitModule } from 'angular-split';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { ContextMenuModule } from 'ngx-contextmenu';
import { AngularDateTimePickerModule } from 'angular2-datetimepicker';
import { DatePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { CKEditorModule } from 'ng2-ckeditor';
import { IonTagsInputModule} from "ionic-tags-input";

//Page
import { HomePage } from '../pages/home/home';
import { MasterPage } from '../pages/master/master';
import { LoginPage } from '../pages/login/login';
import { HeaderPage } from '../pages/header/header';
import { SideMenuPage } from '../pages/side-menu/side-menu';
import { BreadcrumbsPage } from '../pages/breadcrumbs/breadcrumbs';
import { DrivePage } from '../pages/drive/drive';
import { TemplateListsPage } from '../pages/template-lists/template-lists';
import { FileUploadPage } from '../pages/file-upload/file-upload';
import { ResetPasswordPage } from '../pages/reset-password/reset-password';
import { DriveSharePage } from '../pages/drive-share/drive-share';
import { SharePage } from '../pages/share/share';
import { SchedulerPage } from '../pages/scheduler/scheduler';
import { ContextMenuFolderPage } from '../pages/context-menu-folder/context-menu-folder';
import { ExcelUploadPage } from '../pages/excel-upload/excel-upload';
import { ForgotPasswordPage } from '../pages/forgot-password/forgot-password';
import { UserManagement } from '../pages/user_management/user_management';
import {CreateAppModal} from '../pages/createapp-modal-popup/createapp-modal'

//component
import { SchedulerMailTimePopupComponent} from '../components/scheduler-mail-time-popup/scheduler-mail-time-popup';
import { MyGridApplicationComponent } from "../components/my-grid-application/my-grid-application";
import { VersionHistoryComponent } from '../components/version-history/version-history';
import { VerticalTabComponent } from '../components/vertical-tab/vertical-tab';
import { FormGridComponent } from '../components/form-grid/form-grid';
import { HeaderDetailComponent } from '../components/header-detail/header-detail';
import { defaultForm } from '../components/form/defaultForm/defaultForm.component';
import { ExpandableComponent } from '../components/expandable/expandable';
import { RuleEngineComponent } from '../components/rule-engine/rule-engine';
import { RuleEngineSetupComponent } from '../components/rule-engine-setup/rule-engine-setup';
import { ButtonTypeRendererComponent } from '../components/agGridRenderer/button-type-renderer/button-type-renderer';
import { ImageRendererComponent } from '../components/agGridRenderer/image-renderer/image-renderer';
import { AgGridSlideViewComponent } from '../components/agGridRenderer/ag-grid-slide-view/ag-grid-slide-view';
import { WatchTabViewComponent } from '../components/watch-tab-view/watch-tab-view'
import { PublicShareComponent } from '../components/public-share/public-share';
import { PrivateShareComponent } from '../components/private-share/private-share';
import {ManageAccountComponent} from '../components/manage-account/manage-account';
import {HyperLinkComponent} from '../components/hyper-link/hyper-link';

// component holder
import { MainComponentHolderComponent } from "../components/main-component-holder/main-component-holder";
import { ComponentHolderComponent } from "../components/component-holder/component-holder";

// forms
import { ButtonRendererComponent } from '../components/button-renderer/button-renderer';
import { RatioParentComponent } from '../components/agGridRenderer/ratio-parent/ratio-parent';
import { RenderMultipleDataCellComponent } from '../components/agGridRenderer/render-multiple-data-cell/render-multiple-data-cell';
import { AgratioComponent } from '../components/agGridRenderer/agratio/agratio';
import { MailCampaignComponent } from '../components/form/mail-campaign/mail-campaign';
import { AdvanceSearchComponent } from '../components/form/advance-search/advance-search';

//providers
import { DriveServiceProvider } from '../providers/drive-service/drive-service';
import { DeskPageServiceProvider } from '../providers/desk-page-service/desk-page-service';
import { StoreWrapProvider } from '../providers/store-wrap/store-wrap';
import { PipesModule } from '../pipes/pipes.module';
import { LoginService } from '../providers/login-service/login-service';
import { ConfigureServiceProvider } from '../providers/configure-service/configure-service';
import { EventServiceProvider } from '../providers/event-service/event-service';
import { EncrDecrServiceProvider } from '../providers/encr-decr-service/encr-decr-service';
import { componentHolderService } from '../providers/component-holder.service/component-holder.service';
import { ConfigApiServiceProvider } from '../providers/config-api-service/config-api-service';
import { TemplateManagerProvider } from '../providers/template-manager/template-manager';
import { CommunicationServiceProvider } from '../providers/communication-service/communication-service';
import { NotifyServiceProvider } from '../providers/notify-service/notify-service';



import { PublicShareServiceProvider } from '../providers/public-share-service/public-share-service';
import { ContactManagerProvider } from '../providers/contact-manager/contact-manager';
import { MailSchedulerProvider } from '../providers/mail-scheduler/mail-scheduler';
import { ExcelService } from '../providers/excel-service/excel-service';
import { NgSelectModule } from '@ng-select/ng-select';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';


import { ComponentLibModule,ComponentLibService} from 'drive-uilib';
import {EpcuiModule,EpcuiService} from "epcui"
import { FolderPropertiesComponent} from '../components/folder-properties/folder-properties';
import { FolderSecurityPropertyComponent } from '../components/folder-security-property/folder-security-property';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


@NgModule({
  declarations:[
    DriveApp,
    HomePage,
    MasterPage,
    LoginPage,
    HeaderPage,
    SideMenuPage,
    DrivePage,
    DriveSharePage,
    SharePage,
    ResetPasswordPage,
    TemplateListsPage,
    SchedulerPage,
    FileUploadPage,
    BreadcrumbsPage,
    ContextMenuFolderPage,
    ForgotPasswordPage,
    ExcelUploadPage,
    CreateAppModal,

    //components
    SchedulerMailTimePopupComponent,
    MyGridApplicationComponent,
    ComponentHolderComponent,
    ComponentHolderComponent,
    MainComponentHolderComponent,

    ManageAccountComponent,
    MailCampaignComponent,
    PublicShareComponent,
    PrivateShareComponent,
    VersionHistoryComponent,
    ButtonRendererComponent,
    ButtonTypeRendererComponent,
    ImageRendererComponent,
    AgGridSlideViewComponent,
    RenderMultipleDataCellComponent,
    RatioParentComponent,
    AgratioComponent,
    defaultForm,
    VerticalTabComponent,
    ExpandableComponent,
    FormGridComponent,
    HeaderDetailComponent,
    RuleEngineComponent,
    RuleEngineSetupComponent,
    UserManagement,
    FolderPropertiesComponent,
    FolderSecurityPropertyComponent,
    WatchTabViewComponent,
    AdvanceSearchComponent,
    HyperLinkComponent
  ],

  imports: [
    IonicModule.forRoot(DriveApp),
    AngularEditorModule,
    BrowserModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    PipesModule,
    AgGridModule.withComponents(
      [MyGridApplicationComponent]
    ),
    AgGridModule.withComponents(
      [ButtonRendererComponent,ButtonTypeRendererComponent,RatioParentComponent, 
        AgratioComponent, 
        ImageRendererComponent, 
        RenderMultipleDataCellComponent,
        AgGridSlideViewComponent,
        HyperLinkComponent
      ]
    ),
    AngularSplitModule.forRoot(),
    ContextMenuModule.forRoot({ autoFocus: true}),
    Ng4LoadingSpinnerModule.forRoot(),
    AngularDateTimePickerModule,
    ComponentLibModule,
    NgSelectModule,
    IonTagsInputModule,
    CKEditorModule,
    EpcuiModule,
    OwlDateTimeModule, OwlNativeDateTimeModule ,
    BrowserAnimationsModule
  ],
  entryComponents: [
    DriveApp,
    HomePage,
    MasterPage,
    LoginPage,
    HeaderPage,
    SideMenuPage,
    DriveSharePage,
    SharePage,
    DrivePage,
    ContextMenuFolderPage,
    ResetPasswordPage,
    TemplateListsPage,
    PublicShareComponent,
    PrivateShareComponent,
    SchedulerPage,
    SchedulerMailTimePopupComponent,
    MyGridApplicationComponent,
    ManageAccountComponent,
    ComponentHolderComponent,
    MainComponentHolderComponent,
    VerticalTabComponent,
    FileUploadPage,
    DriveSharePage,
    BreadcrumbsPage,
    MailCampaignComponent,
    defaultForm,
    FormGridComponent,
    HeaderDetailComponent,
    RuleEngineComponent,
    RuleEngineSetupComponent,
    ExcelUploadPage,
    ForgotPasswordPage,
    UserManagement,
    AgGridSlideViewComponent,
    FolderPropertiesComponent,
    FolderSecurityPropertyComponent,
    VersionHistoryComponent,
    WatchTabViewComponent,
    AdvanceSearchComponent,
    CreateAppModal,
    HyperLinkComponent
  ],
  bootstrap: [IonicApp],
  exports: [],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    DriveServiceProvider,
    DeskPageServiceProvider,
    StoreWrapProvider,
    EpcuiService,
    componentHolderService,
    LoginService,
    ConfigureServiceProvider,
    EventServiceProvider,
    EncrDecrServiceProvider,
    DatePipe,
    TemplateManagerProvider,
    ConfigApiServiceProvider,
    PublicShareServiceProvider,
    ContactManagerProvider,
    MailSchedulerProvider,
    ComponentLibService,
    ExcelService,
    CommunicationServiceProvider,
    NotifyServiceProvider
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts